'use strict';

/**
 * iPhone Duo viewport detection (Modesh).
 *
 * Mirrors the bp(duo*) mixin points in scss/base/_mixin.scss, driven by the
 * $duo-* variables in scss/base/_variables.scss. Keep both in sync.
 *
 *   Unfolded, portrait    669 x 951
 *   Unfolded, landscape   951 x 543  (measured on device with Safari's bar)
 *
 * Folded is deliberately NOT modelled: measured on device it is 382 x 580,
 * inside the ordinary iPhone range, so it cannot be told apart from a phone by
 * viewport size and simply gets the phone styles.
 *
 * Swiper breakpoints are min-width only and cannot express orientation, so
 * components that need a Duo-specific swiper config use these matchMedia
 * queries instead.
 */

var TOLERANCE = 20;

/**
 * Builds a width-range media query for one Duo state.
 * @param {number} width - nominal viewport width in CSS px
 * @param {string} orientation - portrait | landscape
 * @returns {string} media query
 */
function rangeQuery(width, orientation) {
    return 'only screen and (min-width: ' + (width - TOLERANCE) + 'px)'
        + ' and (max-width: ' + (width + TOLERANCE) + 'px)'
        + ' and (orientation: ' + orientation + ')';
}

var QUERIES = {
    unfoldedPortrait: rangeQuery(669, 'portrait'),
    unfoldedLandscape: rangeQuery(951, 'landscape')
};

/**
 * @param {string} query - media query
 * @returns {boolean} whether the current viewport matches
 */
function matches(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
}

var servedMobileCache = null;

/**
 * Is this page the mobile (m/) variant?
 *
 * Several consumers are bundled into desktop entries too, and a desktop
 * browser window that happens to be 931-971px wide would otherwise match the
 * landscape query and get phone behaviour. The mobile layout is the only one
 * that links globalMobile(.rtl).css (m/common/htmlHead*.isml), so use that as
 * the marker. Bundles load with `defer`, so the <head> links exist by now.
 * @returns {boolean} true when the mobile templates/styles are being served
 */
function servedMobile() {
    if (servedMobileCache === null) {
        servedMobileCache = !!(document.querySelector
            && document.querySelector('link[rel="stylesheet"][href*="globalMobile"]'));
    }

    return servedMobileCache;
}

/**
 * @returns {boolean} true on iPhone Duo unfolded, either orientation
 */
function isUnfolded() {
    return servedMobile()
        && (matches(QUERIES.unfoldedPortrait) || matches(QUERIES.unfoldedLandscape));
}

/**
 * Runs callback whenever the Duo fold state / orientation changes
 * (resize + orientationchange, debounced).
 * @param {Function} callback - receives { unfolded: boolean }
 */
function onChange(callback) {
    var last = isUnfolded();
    var timer;
    var check = function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
            var unfolded = isUnfolded();
            if (unfolded !== last) {
                last = unfolded;
                callback({ unfolded: unfolded });
            }
        }, 150);
    };
    $(window).on('resize orientationchange', check);
}

module.exports = {
    QUERIES: QUERIES,
    isUnfolded: isUnfolded,
    onChange: onChange
};
